import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { CelumIcon } from '@celum/common-components/icon';
import { SpaceAwareTooltipDirective } from '@celum/ng2base/directives';
import { StripUrlProtocolPipe } from '@celum/ng2base/pipes';

import { ServiceTabItem } from '../../model/service-tab-item/service-tab-item';
import { SubServiceTabItem } from '../../model/sub-service-tab-item/sub-service-tab-item';
import { SubServiceTabItemComponent } from '../sub-service/sub-service-tab-item-component';

@Component({
  selector: 'systembar-service-tab-item',
  templateUrl: './service-tab-item-component.html',
  styleUrls: ['./service-tab-item-component.less'],
  imports: [
    NgClass,
    MatTooltip,
    TranslatePipe,
    MatMenuTrigger,
    CelumIcon,
    SubServiceTabItemComponent,
    MatMenu,
    StripUrlProtocolPipe,
    MatMenuItem,
    SpaceAwareTooltipDirective,
    NgTemplateOutlet
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ServiceTabItemComponent implements OnInit, OnDestroy {
  @Input() public service: ServiceTabItem;

  @HostBinding('class.systembar-service-tab-item') public hostCls = true;

  protected isMenuOpen = signal(false);

  private subscription: Subscription;

  constructor(private changeDetector: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.subscription = this.service.onSelectedValueChanged.subscribe(() => this.changeDetector.markForCheck());
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public clicked(): void {
    this.service.subServices?.forEach(subService => (subService.selected = false));

    // in case there are defined context menu items adapt behaviour to:
    // 1 item - propagate click on this single item since no context menu should appear in this case
    // more items - don't propagate click at all as it will be propagated once specific context menu item is clicked
    if (this.service.contextMenuItems.length > 0) {
      if (this.service.contextMenuItems.length === 1) {
        this.service.contextMenuItems[0].onClick();
      }

      return;
    }

    this.service.selected = this.service.active;

    if (this.service.onClick) {
      this.service.onClick();
    }

    this.changeDetector.markForCheck();
  }

  public subServiceClicked(emitter: SubServiceTabItem): void {
    this.service.subServices.forEach(subService => (subService.selected = subService === emitter));
    this.service.selected = false;
    this.changeDetector.markForCheck();
  }
}
